import { createSlice } from '@reduxjs/toolkit';

const initialDeliveriesState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: null,
  deliverForView: undefined,
  error: null,
  msg: null,
};
export const callTypes = {
  list: 'list',
  action: 'action',
};

export const deliveriesSlice = createSlice({
  name: 'deliveries',
  initialState: initialDeliveriesState,
  reducers: {
    catchError: (state, action) => {
      //state.error = `${action.type}: ${action.payload.error}`;
      state.error = `${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    sendMsg: (state, action) => {
      state.msg = `${action.payload.msg}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      state.msg = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    // findDeliveries
    deliveriesFetched: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.msg = null;
      state.entities = entities;
      state.totalCount = totalCount;
      return state;
    },
    // getDeliverById
    deliverFetched: (state, action) => {
      state.actionsLoading = false;
      state.deliverForView = action.payload.deliverForView;
      state.error = null;
      state.msg = null;
      return state;
    },
    // create deliver
    deliverCreated: (state, action) => {
      state.error = null;
      state.msg = null;
      state.actionsLoading = false;
      state.deliverForView = action.payload.deliverForView;
      return state;
    },

    // update Deliver
    deliverUpdated: (state, action) => {
      state.error = null;
      state.msg = null;
      state.actionsLoading = false;
      state.deliverForView = action.payload.deliverForView;
      return state;
    },
    // delete deliver
    deliverDeleted: (state, action) => {
      state.error = null;
      state.msg = null;
      state.actionsLoading = false;
      state.entities = state.entities.filter(
        (el) => el.id !== action.payload.id
      );
      return state;
    },
    // create deliver
    deliverCleared: (state, action) => {
      state.error = null;
      state.msg = null;
      state.actionsLoading = false;
      state.deliverForView = null;
      return state;
    },
  },
});
